var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.714355 0.714355H16.9048H33.0953V26.4286L35.9525 29.2858H0.714355V0.714355Z",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 15H19.7621",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 21.6667H25.4764",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 8.33325H25.4764",
    stroke: "#99999F",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.6762,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.5655d528.svg";
export { ForwardRef as ReactComponent };